import {makeStyles} from "@material-ui/styles";
import Link from "next/link";
import { useRouter } from 'next/router';

const useStyles = makeStyles((theme) => {
	return {
		wrapper: {
			margin: '0',
		},
		title: {
			color: theme.palette.primary.lowlight,
			textAlign: 'center'
		},
		list: {
			padding: 0,
			display: 'flex',
			flexWrap: 'wrap',
			gap: '10px',
			justifyContent: 'center',
			[theme.breakpoints.down('xs')]: {
				gap: '5px',
				justifyContent: 'space-around',
			},

			[theme.breakpoints.up('md')]: {
				justifyContent: 'space-between',
				flexWrap: 'nowrap',
			},
		},
		listItem: {
			display: 'flex',
			flexGrow: '1',
			flexBasis: '185px',
			maxWidth: '50%',
			borderRadius: 0,
			overflow: 'hidden',
			alignItems: 'top',
			[theme.breakpoints.down('xs')]: {
				flexBasis: '40%',
				minWidth: '100px',
			},
			[theme.breakpoints.up('sm')]: {
				flexBasis: '23%',
			},
			[theme.breakpoints.up('md')]: {
				flexBasis: '20%',
			},
			[theme.breakpoints.up('lg')]: {
				flexBasis: '10%',
			},
			'& a': {
				display: 'inline-flex',
				color: theme.palette.primary.color,
				flexDirection: 'column',
				gap: '5px',
				lineHeight: '25px',
				fontSize: '14px',
				letterSpacing: 0.5,
				whiteSpace: 'nowrap',
				textDecoration: 'none',
				width: '100%',
                textUnderlineOffset: '5px',
                position: 'relative',

                '&.active:after': {
                    content: '""',
                    position: 'absolute',
                    backgroundColor: 'currentColor',
                    height: 1,
                    width: '90%',
                    top: 7,
                    left: '5%',
                    transition: 'opacity 0.2s ease',
                },
                '&.active:before': {
                    content: '""',
                    position: 'absolute',
                    backgroundColor: 'currentColor',
                    height: 1,
                    width: '90%',
                    bottom: 7,
                    left: '5%',
                    transition: 'opacity 0.2s ease',
                },
				'&:hover': {
					textDecoration: 'underline',

				},
                '&:hover:before': {
                    opacity: 0,
                },
                '&:hover:after': {

                    opacity: 0,
                },
				[theme.breakpoints.down('xs')]: {
					fontSize: 13
				},

				'& img': {
					width: '100%',
					aspectRatio: '1 / 1.08',
					objectFit: 'cover',
					borderRadius: '15px',
					padding: '5px 5px 0',
					'&:hover': {
						opacity: 0.8
					},
					[theme.breakpoints.down('xs')]: {
						padding: 0,
					},
				},
				'& span': {
					textAlign: 'center',
					fontWeight: 500,
					letterSpacing: '2px',
					padding: '10px 5px',
					borderRadius: 1,
					border: '1px solid rgba(0,0,0,0.1)',
					color: theme.palette.primary.color,
					backgroundColor: theme.palette.primary.background,
					lineHeight: 1,
					[theme.breakpoints.up('xs')]: {
						padding: '15px 10px',
					},
				},
				'& img + span': {
					borderColor: 'transparent'
				}
			}
		},
	}
}, {name: 'FrontpageBarker'});

export default function FrontpageBarker({ block }) {
	const classes = useStyles();
	const CMSContent = block.slots[0]?.config;
    const router = useRouter();

    function isMatchingCategoryUrl(routerPath, categoryUrl) {
        let routerPathWithoutQuery = routerPath.split('?')[0];
        return routerPathWithoutQuery === categoryUrl;
    }
	function renderListItem(item, index) {
		if (item?.title === '') {
			return '';
		}
		const url = item?.categorySlug ? '/' + item.categorySlug : item.url;

        return (
            <li className={classes.listItem} key={'category-menu-item-' + index}>
                <Link href={url}  onClick={() => trackingActions.click({})}>
                    <a className={isMatchingCategoryUrl(router.asPath, url) ? 'active' : ''}
                        style={{
						color: CMSContent?.textColor?.value,
					}}>
						{ item?.media?.value &&
                        <img loading="lazy" src={item?.media?.value} alt={''} />
						}
                        <span style={{
                                color: CMSContent?.textColor?.value,
                                backgroundColor: CMSContent?.backgroundColor?.value,
                            }}>
                            {item?.title}
                        </span>
                    </a>
                </Link>
            </li>
        );
    }

	return (
        <div className={classes.wrapper}>
            {CMSContent.heading && <h2 className={classes.title}>{CMSContent.heading.value}</h2>}
            {CMSContent.entries.value.length > 0 && (
                <nav aria-label={'selected categories'}>
                    <ul className={classes.list}>
                        {CMSContent.entries.value.map((item, index) => renderListItem(item, index))}
                    </ul>
                </nav>
            )}
        </div>
    );
}
